export const dashboard = {
  metrics: {
    totalContent: {
      title: 'Total Content',
      description: 'Completed blogs',
    },
    generating: {
      title: 'Generating',
      description: 'Currently in progress',
    },
    successRate: {
      title: 'Success Rate',
      description: 'Completed vs failed',
    },
    thisMonth: {
      title: 'This Month',
      description: 'Content created',
    },
    avgPerWeek: {
      title: 'Avg / Week',
      description: 'Last 4 weeks',
    },
    failed: {
      title: 'Failed',
      description: 'Generation errors',
    },
  },
  recentContent: {
    title: 'Recent Content',
    empty: 'No content yet',
    viewAll: 'View all',
    status: {
      generating: 'Generating',
      completed: 'Completed',
      failed: 'Failed',
    },
  },
  languageDistribution: {
    title: 'Languages',
    empty: 'No data',
  },
  topKeywords: {
    title: 'Top Keywords',
    empty: 'No keywords yet',
  },
  quickActions: {
    newContent: 'New Content',
    viewContents: 'My Contents',
  },
  trend: {
    up: '+{{value}}% vs last month',
    down: '{{value}}% vs last month',
    neutral: 'Same as last month',
  },
  empty: {
    title: 'No content yet',
    description: 'Create your first piece of content to see your dashboard come to life.',
    cta: 'Create Content',
  },
  error: {
    title: 'Error loading dashboard',
    retry: 'Retry',
  },
} as const
